import type { WebRPCError } from '$lib/api/rpc';

export function getErrorMessage(error: unknown) {
	if (typeof error == 'string') {
		try {
			error = JSON.parse(error);
			// eslint-disable-next-line no-empty
		} catch (e) {}
	}

	if (instanceOfWebRPCError(error)) return error.msg;
	if (error instanceof Error) return error.message;
	return String(error);
}

export function instanceOfWebRPCError(error: unknown): error is WebRPCError {
	if (error && typeof error == 'object') return 'msg' in error;
	return false;
}
